import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@app/components/toastr/toast.service';

@Component({
  selector: 'app-ownership-create',
  templateUrl: './ownership-create.component.html',
  styleUrls: ['./ownership-create.component.scss']
})
export class OwnershipCreateComponent implements OnInit {

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  constructor(private ActivatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private http: HttpClient, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string,private toast: ToastService) { }

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];

      this.http.get<any>(`${environment.apiUrl}/ownershipById/${id}`, { headers: { 'Userinfo': JSON.stringify({ _id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole') }) } }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if (data.data != null) {
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              ownership: data.data.ownership,
            });
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    });

    this.Form = this.formBuilder.group({
      ownership: ['', Validators.required],
      _id: ['',],
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {

    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == 'Submit') {
      let data = ({
        "ownership": this.Form.value.ownership,
      })
      this.http.post<any>(`${environment.apiUrl}/ownership/`, data, { headers: { 'Userinfo': JSON.stringify({ _id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole') }) } }).subscribe(
        res => {
          (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if (res.status == '500') {
            this.message = res.message;
            this.class = 'btn-primary rounded px-1 py-1';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return 0;
          } else {
            this.message = 'Successfully Added';
            this.class = 'btn-success rounded px-1 py-1';
             this.toast.show("Successfully Added", "success");
            this.router.navigateByUrl('/ownership/list');
          }
        },
        (err: HttpErrorResponse) => {
         this.toast.show("Failed to save Ownership", "error");
        });
    } else {
      let data = ({
        "ownership": this.Form.value.ownership,
        "_id": this.Form.value._id,
      })
      this.http.put<any>(`${environment.apiUrl}/ownership/`, data, { headers: { 'Userinfo': JSON.stringify({ _id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole') }) } }).subscribe(
        res => {
          (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if (res.status == '500') {
            this.message = res.message;
            this.class = 'btn-primary rounded px-1 py-1';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return 0;
          } else {
            this.message = 'Successfully Updated';
            this.class = 'btn-success rounded px-1 py-1';
             this.toast.show("Successfully Updated", "success");
            this.router.navigateByUrl('/ownership/list');
          }
        },
        (err: HttpErrorResponse) => {
          this.toast.show("Failed to save Ownership", "error");
        });
    }
  }

}
